/**
 * Runtime config, served by the backend as /config.js (see server/config.js) and loaded by a
 * <script> in index.html before the bundle. Read through this getter rather than captured at
 * import time so tests can swap `window.__APP_CONFIG__` per case.
 */
export interface AppConfig {
  demoMode: boolean;
  tenantBaseDomain: string;
  tenantProtocol: string;
  entraClientId: string;
  entraTenantId: string;
  entraRedirectUri: string | null;
}

export function getAppConfig(): AppConfig {
  const config = window.__APP_CONFIG__;
  if (!config) {
    throw new Error('Missing window.__APP_CONFIG__ — /config.js did not load before the app bundle');
  }

  return config;
}
